import { ArrowUpRight, ShoppingBag, Star } from "lucide-react";
import { PRODUCTS, waLink } from "@/lib/config";

export default function Products() {
  return (
    <div data-testid="products-page" className="pt-36 pb-24 min-h-screen bg-brand-slate">
      {/* Header */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 hero-spotlight" />
        <div className="absolute inset-0 grid-overlay" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand-cyan/25 bg-brand-cyan/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand-cyan">
            <ShoppingBag className="h-3.5 w-3.5" /> The Marketplace
          </span>
          <h1 className="mt-6 font-heading font-extrabold tracking-tighter text-white text-5xl sm:text-6xl">
            Plug-and-play <span className="text-gradient">growth assets</span>
          </h1>
          <p className="mt-5 text-lg text-slate-300 max-w-2xl mx-auto">
            Battle-tested templates, scripts and playbooks we use with our own real estate clients. Download, deploy, and start closing.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="relative mx-auto max-w-7xl px-5 sm:px-8 mt-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {PRODUCTS.map((p) => (
            <div
              key={p.id}
              data-testid={`product-card-${p.id}`}
              className="group flex flex-col glass-panel rounded-3xl overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-cyan/30"
            >
              <div className="relative h-52 overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/20 to-transparent" />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1 rounded-full bg-brand-blue px-3 py-1 text-xs font-semibold text-white">
                  <Star className="h-3 w-3 fill-white" /> {p.badge}
                </span>
              </div>

              <div className="flex flex-col flex-1 p-6">
                <h2 className="font-heading font-bold text-xl text-white">{p.name}</h2>
                <p className="mt-1 text-sm text-brand-cyan font-medium">{p.tagline}</p>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.description}</p>

                <div className="mt-6 flex items-end gap-2">
                  <span className="font-heading font-extrabold text-3xl text-white">{p.price}</span>
                  <span className="text-slate-500 line-through text-sm mb-1">{p.oldPrice}</span>
                </div>

                <a
                  href={p.checkout}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`product-buy-${p.id}`}
                  className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-brand-blue hover:bg-brand-blueHover px-6 py-3.5 font-semibold text-white transition-all duration-300 hover:scale-[1.02] active:scale-95"
                >
                  Buy Now <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
